import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref } from "vue"

const _hoisted_1 = { class: "hidden md:flex gap-2 flex-wrap" }

import { storeToRefs } from 'pinia'
import FilterBtn from '@/components/Dashboard/Header/components/FilterBtn.vue'
import { useFilterStationsStore } from '@/components/Filters/useFilterStation'
import { useCompanyStore } from '@/pinia-store/useCompanyStore'
import { computed } from 'vue'
import { useHealthUnitStore } from '@/pinia-store/useHealthUnitStore'
import { useScheduleStore } from '@/pinia-store/useScheduleStore'
import { usePositionStore } from '@/pinia-store/usePositionStore'
import { useDoctorStore } from '@/pinia-store/useDoctorStore'
import { useShiftStore } from '@/pinia-store/useShiftStore'
import { format } from 'date-fns'
import { daysWeekObj } from '@/utils/date'
import { useSectorStore } from '@/pinia-store/useSectorStore'
import { useSpecialtyStore } from '@/pinia-store/useSpecialtyStore'
import { useFeatureFlags } from '@/hooks/useFeatureFlags'
import { formatCoverageStatusFilterLabel } from '@/utils/coverageFilters'


export default /*#__PURE__*/_defineComponent({
  __name: 'filters.used',
  setup(__props) {

const useFilterStations = useFilterStationsStore()
const { filters } = storeToRefs(useFilterStations)

const { listCompanies } = storeToRefs(useCompanyStore())
const { listHealthUnits } = storeToRefs(useHealthUnitStore())
const { listSchedules } = storeToRefs(useScheduleStore())
const { listPositions } = storeToRefs(usePositionStore())
const { listDoctorsCompany } = storeToRefs(useDoctorStore())
const { listShifts } = storeToRefs(useShiftStore()) // Refs dos Turnos

// A11: chips de setor/especialidade só com a flag ligada (na base o de setor era TODO).
const isDashboardV2 = useFeatureFlags().flags.enabledDashboardV2
const sectorStore = useSectorStore()
const specialtyStore = useSpecialtyStore()
// Sem o catálogo carregado (deep link), o chip mostra `#id` em vez de sumir.
const sectorNames = computed(() =>
  (filters.value.sectorIds ?? [])
    .map((id) => sectorStore.sectorName(Number(id)) ?? `#${id}`)
    .join(', ')
)
const specialtyNames = computed(() =>
  [
    ...(filters.value.specialtyIds ?? []).map(
      (id) => specialtyStore.specialtyName(`o:${id}`) ?? `#${id}`
    ),
    ...(filters.value.companySpecialtyIds ?? []).map(
      (id) => specialtyStore.specialtyName(`c:${id}`) ?? `#${id}`
    )
  ].join(', ')
)

const company = computed(() => {
  return listCompanies.value.find((c) => +c.value === Number(filters.value.company))?.title
})

const healthUnits = computed(() => {
  const healthUnits = listHealthUnits.value.filter((h) =>
    filters.value.healthUnits?.map((hu) => Number(hu))?.includes(+h.value)
  )
  return healthUnits.map((h) => h.title)
})

const schedules = computed(() => {
  const schedules = listSchedules.value.filter((h) =>
    filters.value.schedules?.map((hu) => Number(hu))?.includes(+h.value)
  )
  return schedules.map((h) => h.title)
})

const shifts = computed(() => {
  const shifts = listShifts.value.filter((s) =>
    filters.value.shifts?.map((id) => Number(id))?.includes(+s.id)
  )
  return shifts.map((s) => s.name)
})

const positions = computed(() => {
  const positions = listPositions.value.filter((h) =>
    filters.value.positions?.map((hu) => Number(hu))?.includes(+h.id)
  )
  return positions.map((h) => h.name)
})

const doctors = computed(() => {
  const doctors = listDoctorsCompany.value.filter((h) =>
    filters.value.doctors?.map((hu) => Number(hu))?.includes(+h.value)
  )
  return doctors.map((h) => h.title)
})

const weekOfMonth = computed(() => {
  if (!filters.value.weekOfMonth?.length) return null
  const labels = ['A', 'B', 'C', 'D', 'E']
  return filters.value.weekOfMonth
    .map((w) => labels[Number(w)])
    .filter(Boolean)
    .join(', ')
})

const stationWeekParity = computed(() => {
  const val = filters.value.stationWeekParity
  if (val === undefined || val === null) return null
  return Number(val) === 0 ? 'Par' : 'Ímpar'
})

const coverageStatusLabel = computed(() =>
  formatCoverageStatusFilterLabel(filters.value.coverageStatus ?? [])
)

const isOpenDoctorStation = computed(() => {
  const val = filters.value.isOpenDoctorStation
  if (val === true) return 'Apenas Vagas Abertas'
  if (val === false) return 'Apenas Vagas Preenchidas'
  return null
})

function formatDate(date: string | Date) {
  if (typeof date !== 'string') {
    return format(date, 'dd/MM/yyyy')
  }
  return date.replace(/(\d{4})-(\d{2})-(\d{2})/, '$3/$2/$1')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (company.value)
      ? (_openBlock(), _createBlock(FilterBtn, {
          key: 0,
          text: `Empresa: ${company.value}`,
          shouldRemove: false
        }, null, 8, ["text"]))
      : _createCommentVNode("", true),
    (healthUnits.value?.length)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(healthUnits.value, (healthUnit) => {
          return (_openBlock(), _createBlock(FilterBtn, {
            key: healthUnit,
            text: `Unidade: ${healthUnit}`,
            shouldRemove: false
          }, null, 8, ["text"]))
        }), 128))
      : _createCommentVNode("", true),
    (schedules.value?.length)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(schedules.value, (schedule) => {
          return (_openBlock(), _createBlock(FilterBtn, {
            key: schedule,
            text: `Escala: ${schedule}`,
            shouldRemove: false
          }, null, 8, ["text"]))
        }), 128))
      : _createCommentVNode("", true),
    (shifts.value?.length)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(shifts.value, (shift) => {
          return (_openBlock(), _createBlock(FilterBtn, {
            key: shift,
            text: `Turno: ${shift}`,
            shouldRemove: false
          }, null, 8, ["text"]))
        }), 128))
      : _createCommentVNode("", true),
    (positions.value?.length)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 4 }, _renderList(positions.value, (position) => {
          return (_openBlock(), _createBlock(FilterBtn, {
            key: position,
            text: `Posição: ${position}`,
            shouldRemove: false
          }, null, 8, ["text"]))
        }), 128))
      : _createCommentVNode("", true),
    (doctors.value?.length)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 5 }, _renderList(doctors.value, (doctor) => {
          return (_openBlock(), _createBlock(FilterBtn, {
            key: doctor,
            text: `Dr(a): ${doctor}`,
            shouldRemove: false
          }, null, 8, ["text"]))
        }), 128))
      : _createCommentVNode("", true),
    (_unref(filters).valueMin)
      ? (_openBlock(), _createBlock(FilterBtn, {
          key: 6,
          text: `Valor Min.: R$ ${_unref(filters).valueMin}`,
          shouldRemove: false
        }, null, 8, ["text"]))
      : _createCommentVNode("", true),
    (_unref(filters).valueMax)
      ? (_openBlock(), _createBlock(FilterBtn, {
          key: 7,
          text: `Valor Max.: R$ ${_unref(filters).valueMax}`,
          shouldRemove: false
        }, null, 8, ["text"]))
      : _createCommentVNode("", true),
    (_unref(filters).paymentValueMin)
      ? (_openBlock(), _createBlock(FilterBtn, {
          key: 8,
          text: `Valor Aprov Min.: R$ ${_unref(filters).paymentValueMin}`,
          shouldRemove: false
        }, null, 8, ["text"]))
      : _createCommentVNode("", true),
    (_unref(filters).paymentValueMax)
      ? (_openBlock(), _createBlock(FilterBtn, {
          key: 9,
          text: `Valor Aprov Max.: R$ ${_unref(filters).paymentValueMax}`,
          shouldRemove: false
        }, null, 8, ["text"]))
      : _createCommentVNode("", true),
    (_unref(filters).startDate)
      ? (_openBlock(), _createBlock(FilterBtn, {
          key: 10,
          text: `Data Ini.: ${formatDate(_unref(filters).startDate)}`,
          shouldRemove: false
        }, null, 8, ["text"]))
      : _createCommentVNode("", true),
    (_unref(filters).endDate)
      ? (_openBlock(), _createBlock(FilterBtn, {
          key: 11,
          text: `Data Fin.: ${formatDate(_unref(filters).endDate)}`,
          shouldRemove: false
        }, null, 8, ["text"]))
      : _createCommentVNode("", true),
    (_unref(filters).weekDays?.length)
      ? (_openBlock(), _createBlock(FilterBtn, {
          key: 12,
          text: `Dias: ${_unref(filters).weekDays.map((d) => _unref(daysWeekObj)[d]).join(', ')}`,
          shouldRemove: false
        }, null, 8, ["text"]))
      : _createCommentVNode("", true),
    (weekOfMonth.value)
      ? (_openBlock(), _createBlock(FilterBtn, {
          key: 13,
          text: `Semana: ${weekOfMonth.value}`,
          shouldRemove: false
        }, null, 8, ["text"]))
      : _createCommentVNode("", true),
    (stationWeekParity.value)
      ? (_openBlock(), _createBlock(FilterBtn, {
          key: 14,
          text: `Paridade: ${stationWeekParity.value}`,
          shouldRemove: false
        }, null, 8, ["text"]))
      : _createCommentVNode("", true),
    (isOpenDoctorStation.value)
      ? (_openBlock(), _createBlock(FilterBtn, {
          key: 15,
          text: isOpenDoctorStation.value,
          shouldRemove: false
        }, null, 8, ["text"]))
      : _createCommentVNode("", true),
    (coverageStatusLabel.value)
      ? (_openBlock(), _createBlock(FilterBtn, {
          key: 16,
          text: coverageStatusLabel.value,
          shouldRemove: false,
          "data-testid": "consult-coverage-status-chip"
        }, null, 8, ["text"]))
      : _createCommentVNode("", true),
    (_unref(filters).doctorName)
      ? (_openBlock(), _createBlock(FilterBtn, {
          key: 17,
          text: `Médico: ${_unref(filters).doctorName}`,
          shouldRemove: false
        }, null, 8, ["text"]))
      : _createCommentVNode("", true),
    (_unref(isDashboardV2) && _unref(filters).sectorIds?.length)
      ? (_openBlock(), _createBlock(FilterBtn, {
          key: 18,
          text: `Setor(es): ${sectorNames.value}`,
          shouldRemove: false,
          "data-testid": "consult-filter-sector-chip"
        }, null, 8, ["text"]))
      : _createCommentVNode("", true),
    (_unref(isDashboardV2) && specialtyNames.value)
      ? (_openBlock(), _createBlock(FilterBtn, {
          key: 19,
          text: `Especialidade(s): ${specialtyNames.value}`,
          shouldRemove: false,
          "data-testid": "consult-filter-specialty-chip"
        }, null, 8, ["text"]))
      : _createCommentVNode("", true),
    (_unref(filters).doctorStatus !== undefined && _unref(filters).doctorStatus !== null)
      ? (_openBlock(), _createBlock(FilterBtn, {
          key: 20,
          text: `Dr. Confirmou: ${_unref(filters).doctorStatus ? 'Sim' : 'Não'}`,
          shouldRemove: false
        }, null, 8, ["text"]))
      : _createCommentVNode("", true),
    (_unref(filters).crms?.length)
      ? (_openBlock(), _createBlock(FilterBtn, {
          key: 21,
          text: `CRM: ${_unref(filters).crms.join(', ')}`,
          shouldRemove: false
        }, null, 8, ["text"]))
      : _createCommentVNode("", true),
    (_unref(filters).crmStates?.length)
      ? (_openBlock(), _createBlock(FilterBtn, {
          key: 22,
          text: `UF CRM: ${_unref(filters).crmStates.join(', ')}`,
          shouldRemove: false
        }, null, 8, ["text"]))
      : _createCommentVNode("", true),
    (_unref(filters).hasException !== undefined && _unref(filters).hasException !== null)
      ? (_openBlock(), _createBlock(FilterBtn, {
          key: 23,
          text: `Excepcionalidade: ${_unref(filters).hasException ? 'Sim' : 'Não'}`,
          shouldRemove: false
        }, null, 8, ["text"]))
      : _createCommentVNode("", true),
    (_unref(filters).startHour?.length)
      ? (_openBlock(), _createBlock(FilterBtn, {
          key: 24,
          text: `Hora Início: ${_unref(filters).startHour.join(', ')}`,
          shouldRemove: false
        }, null, 8, ["text"]))
      : _createCommentVNode("", true),
    (_unref(filters).endHour?.length)
      ? (_openBlock(), _createBlock(FilterBtn, {
          key: 25,
          text: `Hora Fim: ${_unref(filters).endHour.join(', ')}`,
          shouldRemove: false
        }, null, 8, ["text"]))
      : _createCommentVNode("", true)
  ]))
}
}

})